export function initAccessoryToggle(): void {
    const buttons = document.querySelectorAll<HTMLButtonElement>('.accessory-group .showmore');

    buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
            const accessoryGroup = button.closest<HTMLElement>('.accessory-group');
            const btn = event.currentTarget as HTMLElement;

            if (!accessoryGroup) return;

            // Reveal hidden rows inside the group
            const hiddenRows = accessoryGroup.querySelectorAll<HTMLElement>('.accessory-item.hidden');
            const allRows = accessoryGroup.querySelectorAll<HTMLElement>('.accessory-item');

            if (btn.classList.contains('active')) {
                allRows.forEach((row, index) => {
                    if (index >= 3) {
                        row.classList.add('hidden');
                    }
                })
            } else {
                hiddenRows.forEach((row) => row.classList.remove('hidden'));
            }

            // Hide the row that contains the clicked button
            const buttonRow = button.closest<HTMLElement>('.accessory-item');
            if (buttonRow) {
                buttonRow.classList.add('hidden');
            }
            btn.classList.toggle('active');
        });
    });
}